































import { defineComponent, computed } from '@vue/composition-api';
import { ParagraphSize, IconSize } from '@getaccept/lib-ui';
import { Feature, useFeatureStore } from '@getaccept/feature-restriction';
import { storeToRefs } from 'pinia';
import { DashboardWidgetHeaderColor } from '../types/enums/dashboard-widget-header-color';
import { DashboardWidgetValueColor } from '../types/enums/dashboard-widget-value-color';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    count: {
      type: [String, Number],
      required: true,
    },
    countTitle: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: false,
      default: '',
    },
    valueTitle: {
      type: String,
      required: false,
      default: '',
    },
    headerColor: {
      type: String,
      required: false,
      default: DashboardWidgetHeaderColor.Gray39,
    },
    valueColor: {
      type: String,
      required: false,
      default: DashboardWidgetValueColor.Gray96,
    },
    helpText: {
      type: String,
      required: false,
      default: '',
    },
    to: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props) {
    const { features } = storeToRefs(useFeatureStore());
    const routerLink = 'router-link';
    const div = 'div';

    const showChevron = computed(() => componentName.value === routerLink);

    const componentName = computed((): string => {
      if (props.to.includes('dealboard')) {
        return features.value[Feature.Dealboard].restricted ? div : routerLink;
      }
      return props.to ? routerLink : div;
    });

    return {
      ParagraphSize,
      IconSize,
      componentName,
      showChevron,
    };
  },
});
